import { useState } from 'react'
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { AnimatePresence, motion } from 'framer-motion'
import { useNls } from '../../nls/nlsProvider'
import { Button } from '../Common'
import { IconButton } from '../Common/IconButton'

export const MeetingReadinessGate = ({ ready, loading, onOpenLink }: { ready: boolean; loading: boolean; onOpenLink?: () => void }) => {
  const [dismissed, setDismissed] = useState(false)
  const { t } = useNls()
  if (ready) return null
  return (
    <AnimatePresence>
      {!dismissed && (
        <motion.div
          className="meetingReadinessBanner"
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.2 }}
          role="status"
        >
          <CalendarMonthRoundedIcon />
          <div>
            <strong>{loading ? t('NLSMeetingsReadinessChecking') : t('NLSMeetingsReadinessOptional')}</strong>
            <span>{t('NLSMeetingsReadinessBody')}</span>
          </div>
          <Button variant="primary" disabled={loading || !onOpenLink} onClick={onOpenLink}>
            {t('NLSMeetingsReadinessOpenLinkHub')}
          </Button>
          <IconButton
            variant="tertiary"
            size="sm"
            className="meetingReadinessBannerClose"
            aria-label="Dismiss"
            label="Dismiss"
            icon={<CloseRoundedIcon />}
            onClick={() => setDismissed(true)}
          />
        </motion.div>
      )}
    </AnimatePresence>
  )
}
